import Fab from "@mui/material/Fab";
import { PropTypes } from "prop-types";

const ButtonProvoli = (props) => {
  return (
    <Fab
      sx={{ width: 100 }}
      variant="extended"
      color="primary"
      onClick={props.handleClick}
    >
      Προβολη
    </Fab>
  );
};

export default ButtonProvoli;

ButtonProvoli.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
